export default __webpack_public_path__ + "img/days-deals.png";